<template>
    <div>
        <label :for="id">{{label}}</label>
        <select :id="id" 
                :fieldlabel="validationFieldLabel"  
                v-model="selected" 
                v-taurus-validator="'required'"
                class="form-control form-control-lg" >
          <option :value="null">SELECT...</option>
          <option v-for="(option, index) in titleTypes" :key=" id + 'titleType_' + index" :value="option.label">
            {{option.label}}
          </option>
        </select>
        <div :name="id" :invalidfeedback="validationInvalidFeedback"></div> 
    </div>
</template>
<script>
export default {
    props: {
        value: { required: true },
        id: { required: true },
        label: { required: true },
        validationFieldLabel: {required:true},
        validationInvalidFeedback: {required:true}
    },
    components: {
        
    },
    data: () => {
        return {
            titleTypes: [
                {
                id: 1,
                label: 'Mr'
                },
                {
                id: 2,
                label: 'Mrs'
                },
                {
                id: 3,
                label: 'Miss'
                },
                {
                id: 4,
                label: 'Ms'
                },
                {
                id: 5,
                label: 'Dr'
                }
            ],
            selected: null
        }
    },
    mounted() {
        this.selected = this.value;
    },
    computed: {
        
    },
    watch:{
        selected(newVal) {
            this.$emit('input', newVal);
        }
    }
}
</script>